import { UPDATE_GLOBAL_QUERY_PARAMS } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_GLOBAL_QUERY_PARAMS:
            return action.payload
        default:
            return state
    }
}
